/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request from '../utils/request';
import RegistrationForm from './registrationForm';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import RegisterAsSalesRepAndManager from './schema';
import ProfileInfo from './profileInfo';

import '../../assets/css/registration.css';
import '../../assets/css/registration_media_queries.css';
import { CONSTANT, INITIAL_REGISTRATION_FIELD_VALUES } from '../utils/constant';

const Registration = ({ history }) => {
  const {
    KEYS: {
      ROLES: { SALES_SUPPORT }
    }
  } = CONSTANT;

  const [formInitialValue, setFormInitialValue] = useState(
    INITIAL_REGISTRATION_FIELD_VALUES
  );
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isError, setError] = useState(null);
  const [recaptcha, setRecaptcha] = useState();

  const [processingQueryData, setProcessingQueryData] = useState(true);
  const [isRedirectedFromPassport, setIsRedirectedFromPassport] = useState(
    null
  );

  const [allowedDomains, setAllowedDomains] = useState([]);

  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: { labels, confirmationDialog }
    }
  } = localizedStrings;

  const fetchAllowedDomains = async () => {
    const result = await request.get('/domains');

    if (result && result.status === 200) {
      const data = result.data.rows.map(({ name }) => name);
      setAllowedDomains(data);
    }
  };

  // extract and store data from query params (if any)
  useEffect(() => {
    fetchAllowedDomains();

    const queryParams = new URLSearchParams(history.location.search);
    const firstName = decodeURIComponent(queryParams.get('firstName') || '');
    const lastName = decodeURIComponent(queryParams.get('lastName') || '');
    const email = decodeURIComponent(queryParams.get('email') || '');

    if (firstName && lastName && email) {
      setIsRedirectedFromPassport(true);
      setFormInitialValue(previousValue => ({
        ...previousValue,
        firstName,
        lastName,
        email
      }));
    } else {
      setIsRedirectedFromPassport(false);
    }

    setProcessingQueryData(false);
  }, []);

  const onChange = value => {
    setRecaptcha(value);
  };
  const handleSubmit = async (values, actions) => {
    setError(null);
    setLoading(true);
    values.recaptcha = recaptcha;
    const updatedValues = {
      ...values,
      provinces:
        values.role === SALES_SUPPORT
          ? values.multiProvinces
          : [values.province],
      channels:
        values.role === SALES_SUPPORT
          ? values.multiChannels
          : [_.get(values, 'channel.0.id', '')],
      dealership: _.get(values, 'dealership.0.id', '')
    };

    delete updatedValues.province;
    delete updatedValues.channel;
    delete updatedValues.multiChannels;
    delete updatedValues.multiProvinces;

    request
      .post(`/users/register`, updatedValues)
      .then(response => {
        const { status } = response && response.data;
        setShowModal(true);
        setLoading(false);
        if (status) {
          setShowModal(!showModal);
        }
        setLoading(false);
        actions.resetForm({});
      })
      .catch(err => {
        const {
          data: { error }
        } = err && err.response;

        setShowModal(false);
        setLoading(false);
        setError(error);
        actions.resetForm({});
      })
      .then(() => {
        setLoading(false);
        actions.resetForm({});
      });
  };

  return processingQueryData && !allowedDomains ? (
    <></>
  ) : (
    <>
      <div id="main">
        <div id="main-wrapper">
          <div id="main-content">
            <ProfileInfo error={isError} />
            <div id="main-content-login">
              {isRedirectedFromPassport !== null && formInitialValue && (
                <RegistrationForm
                  initialValues={formInitialValue}
                  schema={RegisterAsSalesRepAndManager({ allowedDomains })}
                  labels={labels}
                  showModal={showModal}
                  loading={loading}
                  onChange={value => onChange(value)}
                  confirmationDialog={confirmationDialog}
                  onSubmit={(values, actions) => {
                    handleSubmit(values, actions);
                  }}
                  isRedirectedFromPassport={isRedirectedFromPassport}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Registration.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default Registration;
